var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAlif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.169 12.8269H22.299L13.1359 35.3786H19.014L25.734 17.9602L32.4539 35.3786H38.3321L29.169 12.8269Z",
    fill: "#39B980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2506 51.9516L23.203 51.9461H23.192L23.1884 51.9443C19.7351 51.5984 16.4135 50.5534 13.4159 48.9155C7.62925 45.755 3.04862 40.3911 1.04837 33.5724C-0.953711 26.7517 -0.00025195 19.7664 3.15842 13.9834C4.78351 11.0059 6.99422 8.34871 9.6844 6.19657L9.73747 6.15264C9.7393 6.15081 9.74113 6.14898 9.74296 6.14715C13.727 2.88234 18.6023 0.708231 23.8856 0.0237907C23.9131 0.0201306 24.0869 0.00366011 24.1144 0L26.3288 5.45173C26.2976 5.45356 26.1165 5.47003 26.0854 5.47186C21.373 5.76467 17.001 7.53617 13.4854 10.3636C13.4305 10.4075 13.3738 10.4533 13.3189 10.4972C13.231 10.5704 13.1432 10.6418 13.0572 10.7168L13.0517 10.7205L13.0444 10.726L13.0371 10.7333L13.0316 10.7369C13.0096 10.7571 12.9858 10.7754 12.9639 10.7937C10.9673 12.4371 9.32388 14.4428 8.10323 16.6755C5.63632 21.192 4.89332 26.6529 6.45618 31.982C8.02271 37.3148 11.595 41.5056 16.1079 43.9707C18.4998 45.2756 21.1552 46.0991 23.9167 46.3535C29.9285 46.8476 35.5943 44.9132 39.9297 41.3592C40.1402 41.1872 40.3488 41.0097 40.5519 40.8304L42.7718 46.2912C37.3896 50.4125 30.5123 52.6031 23.2506 51.9516Z",
    fill: "#39B980"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlif);
export default __webpack_public_path__ + "static/media/logo_alif.ba69a4d9a28bf58ce6e566994808e95c.svg";
export { ForwardRef as ReactComponent };